import React from 'react'
import { NOTE_ITEM_LIST } from '../urls'
import { usePostRequest } from '../hooks/request'
import NoteItemForm from './NoteItemForm'

export default function NoteItemCreate({ onSuccess, onCancel }) {
    const roomCreate = usePostRequest({ url: NOTE_ITEM_LIST })

    async function onSubmit(data, actions) {
        await roomCreate.request({ data })
        actions.resetForm()
        onSuccess()
    }

    return (
        <div>
            <NoteItemForm loading={roomCreate.loading} onCancel={onCancel} onSuccess={onSuccess} onSubmit={onSubmit} />
        </div>
    )
}
